import { action, computed, observable } from "mobx";
import { message } from "antd";
import Manager, { IManager } from "../services/Manager";
import { STATUS_VALIDATION_ERROR } from "../constants/http";

interface IErrors {
  old_password?: string[] | null;
  password?: string[] | null;
  password_confirmation?: string[] | null;
}

class ResetPassword {
  @observable
  private _errors: IErrors = {};

  @computed
  get errors(): IErrors {
    return this._errors;
  }

  private manager: IManager = Manager;

  @action
  resetPassword(params: Object): Promise<Response> {
    return this.manager
      .resetPassword(params)
      .then(async (response) => {
        const data = await response.json();

        this._errors = {};

        message.success(data.message);
      })
      .catch(async (response) => {
        const data = await response.json();

        if (response.status === STATUS_VALIDATION_ERROR) {
          this._errors = data.errors;
        }

        message.error(data.message);

        return response;
      });
  }
}

export default ResetPassword;
